module.exports = __webpack_public_path__ + "media/logos/original-lexshares-logo-5a067b4a.png";